import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

export const HomePageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const HomeSectorContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding-bottom: 40px;
  margin-top: -40px;
`;

export const HomeSectorImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #edf1fc;
  opacity: 0.4;
  z-index: -1;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
`;

export const HomeSectorIntroTitle = styled.h3`
  font-size: 12px;
  letter-spacing: 2px;
  color: #3393f0;
  text-align: center;
  margin-bottom: 20px;
  margin-top: 20px;
  position: relative;
`;

export const HomeSectorTitle = styled.h1`
  color: #17224d;
  text-align: center;
  position: relative;
  z-index: 4;
`;

export const HomeSectorCardContainer = styled.div`
  padding: 20px;
  width: 90%;
  margin: 0 auto;
  max-width: 1400px;
  margin-top: 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;

  @media (max-width: 1300px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const HomeSectorCardIcon = styled(FontAwesomeIcon)`
  font-size: 40px;
  margin-bottom: 15px;
  background-color: #edf1fc;
  padding: 20px;
  border-radius: 50%;
  color: #3393f0;
`;

export const HomeSectorCardTitle = styled.h2`
  margin: 10px 0;
  color: #17224d;
`;

export const HomeSectorCardText = styled.p`
  margin: 10px 0;
  font-size: 14px;
  color: #17224d;
  flex-grow: 1;
`;

export const HomeSectorCard = styled.div`
  background-color: white;
  min-width: 22%;
  max-width: 22%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 20px 40px 20px 40px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  border-radius: 24px;
  transition: transform 1.5s ease, background-color 0.3s ease, color 0.3s ease;

  @media (max-width: 1300px) {
    min-width: 100%;
  }

  &:hover {
    transform: translateY(-15%);
    background-color: #3393f0;
    color: white;
  }

  &:hover ${HomeSectorCardTitle}, &:hover ${HomeSectorCardText} {
    color: white;
  }
`;

export const HomeImageWheelContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
`;

export const HomeImageWheel = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  object-fit: cover;
  opacity: ${(props) => (props.isActive ? 1 : 0)};
  transition: opacity 0.5s ease-in-out;
  z-index: ${(props) => (props.isActive ? 1 : 0)};
`;

export const HomeImageWheelGradientOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    135deg,
    rgba(3, 26, 65, 1) 0%,
    rgba(0, 0, 255, 0) 100%
  );
  z-index: 1;
`;

export const HomeTextCard = styled.div`
  position: absolute;
  left: 10%;
  transform: translateY(15%);
  color: white;
  padding: 20px;
  width: 90%;
  max-width: 600px;
  text-align: left;
  font-size: 20px;
  font-weight: bold;
  z-index: 2;
  display: flex;
  gap: 40px;
  flex-wrap: wrap;

  @media (max-width: 742px) {
    padding-right: 80px;
  }
`;

export const HomeTextCardButton = styled.div`
  background-color: #3393f0;
  padding: 25px 30px;
  color: white;
  border-radius: 30px;
  cursor: pointer;
  width: 240px;
  text-align: center;
  transition: background-color 0.6s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);

  @media (max-width: 768px) {
    width: 100%;
    max-width: none;
    margin-bottom: 10px;
    margin-right: 30px;
  }

  @media (max-width: 480px) {
    width: 100%;
    margin-right: 30px;
  }

  &:hover {
    background-color: rgb(5, 103, 201);
  }
`;

export const HomeTextCardIntroTitle = styled.p`
  font-size: 16px;
  color: rgb(33, 100, 167);
  letter-spacing: 2px;
`;

export const HomeTextCardTitle = styled.h1``;

export const HomeTextCardText = styled.p`
  font-size: 18px;
  font-weight: normal;
`;

export const HomeCardContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  width: 90%;
  max-width: 1200px;
  margin: 20px auto;
  flex-wrap: wrap;
  position: relative;
  top: -160px;
  z-index: 3;

  @media (max-width: 650px) {
    flex-direction: column;
    align-items: center;
    top: -100px;
  }

  @media (max-width: 470px) {
    flex-direction: column;
    align-items: center;
    top: -70px;
  }

  @media (max-width: 1224px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const HomeCardIcon = styled(FontAwesomeIcon)`
  color: #3393f0;
  transition: color 0.8s ease-in-out;
  min-width: 50px;
`;

export const HomeCardTitle = styled.h3`
  margin-bottom: 15px;
  color: rgb(33, 100, 167);
  transition: color 0.8s ease-in-out;
`;

export const HomeCard = styled.div`
  background-color: white;
  line-height: 1.3;
  font-size: 14px;
  padding: 30px;
  gap: 15px;
  border-radius: 10px;
  box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.4);
  width: 32%;
  transition: background-color 0.8s ease-in-out;
  display: flex;
  align-items: center;

  &:hover {
    background-color: #3393f0;

    ${HomeCardIcon} {
      color: white;
    }

    ${HomeCardTitle} {
      color: white;
    }
  }

  @media (max-width: 1224px) {
    width: 90%;
  }
`;

export const HomeCardContact = styled.a`
  background-color: white;
  text-decoration: none;
  padding: 30px;
  gap: 15px;
  border-radius: 10px;
  box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.4);
  width: 32%;
  transition: background-color 0.8s ease-in-out;
  display: flex;
  align-items: center;
  background-color: #3393f0;

  &:hover {
    background-color: #3393f0;

    ${HomeCardIcon} {
      color: white;
    }
  }

  @media (max-width: 1224px) {
    width: 90%;
  }
`;

export const HomeAboutCardContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  max-width: 1100px;
  margin: 20px auto;
  position: relative;
  top: -175px;
  z-index: 4;
  border-radius: 12px;

  @media (max-width: 470px) {
    top: -85px !important;
  }

  @media (max-width: 649px) {
    top: -95px;
  }

  @media (max-width: 1224px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const HomeAboutCardImage = styled.img`
  width: 60%;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
  object-fit: cover;

  @media (max-width: 1224px) {
    box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.4);
    width: 81%;
  }
`;

export const HomeAboutCardTextBox = styled.div`
  margin: 10px 0 0 0;

  @media (max-width: 1224px) {
    margin: 0 50px 0 30px;
    width: 83%;
  }
`;

export const HomeAboutCardTextBoxTitle = styled.h1`
  margin-top: 5px;
  color: #17224d;
  margin-left: 20px;
`;

export const HomeAboutCardTextBoxIntroTitle = styled.h2`
  font-size: 16px;
  color: rgb(33, 100, 167);
  margin-left: 20px;
  font-weight: lighter;
  letter-spacing: 2px;
`;

export const HomeAboutCardTextBoxText = styled.p`
  margin-top: 20px;
  margin-left: 20px;
  line-height: 1.8;
`;
